module.exports = __webpack_public_path__ + "img/top-right-corner.a2a2e7a8.svg";